import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const rateSchema = z.object({
  id: z.string(),
  name: z.string(),
  price: z.number(),
  credit: z.number(),
  aiPoints: z.number().default(0),
  isAiPack: z.boolean().default(false),
  published: z.boolean().default(true),
  discountFcfa: z.number().default(0),
  ambassadorCommissionFcfa: z.number().default(0),
  hasTraduction: z.boolean().optional(),
  hasScoringAts: z.boolean().optional(),
  validity: z.number().default(30),
  description: z.string().nullable().optional(),
  type: z.enum(["b2c", "b2b"]),
  isRecommended: z.boolean().optional(),
});

export class RateDto extends createZodDto(rateSchema) {}
